import SiteNotification from '~/types/SiteNotification';

export default ref<SiteNotification | null>(null);
